import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import {Subject, Observable, BehaviorSubject} from 'rxjs';

@Injectable()
export class RouteService {
   
  protected url: string = environment.iCBMSWebApi.url;
  // private routeObservable = new BehaviorSubject<any>({routeid: 0});
  // routeId$ = this.routeObservable.asObservable();
  // routeId$ = new Subject<number>();

  private routeObservable = new BehaviorSubject<number>(1);
  routeId$ = this.routeObservable.asObservable();
  
  private placeObservable = new BehaviorSubject<number>(0);

  public TempRoute: any;

  constructor(private http: HttpClient) { }

saveMyRoutes(data){
  return this.http.post(this.url + 'route',data);
}
saveRoutes(data){
  return this.http.post(this.url + 'route/internal',data);

}
editRoutes(data){
  return this.http.post(this.url + 'route/internal/edit',data);
}
deleteRoutes(id){
  return this.http.delete(this.url + 'route/internal/'+id);

}//external
deleteExternalRoute(id){
  return this.http.delete(this.url + 'route/external/'+id);
}
getMyRoute(id){
  return this.http.get(this.url + 'route/'+id);

}
getAllRoute(){
  return this.http.get(this.url + 'route/all');
}
getRouteByTaxiAssociation(taxiAssocition:number){
return this.http.get(`${this.url}route/bytaxiassc/${taxiAssocition}`);
}

  getRoutesFilter(params:any){
    return this.http.post(`${this.url}route/searchroutes`, params);
  }

getDoNotBelong(){
  return this.http.get(this.url + 'route/belong');
}
getAllRouteLegs(){
  return this.http.get(this.url + 'route/all/leg');
}
saveRouteLeg(data){
  return this.http.post(this.url + 'route/leg',data);
}

  addRouteLeg(data) {
    return this.http.post(this.url + 'route/add', data);
  }
  editRouteLeg(data) {
    return this.http.put(this.url + 'route/edit', data);
  }

  checkByCode(code: any): any {
    return this.http.get(this.url + 'route/check/'+code);
  }

  getRouteLegById(id) {
    return this.http.get(this.url + 'route/byid/' + id);

  }
  addRouteApplication(body) {
    return this.http.post(this.url + 'route/add-to-application', body);
  }
  getRouteTimetable(id){
    return this.http.get(this.url + 'route/timetable/'+id);
  }
  getTableDepartures(id){
    return this.http.get(this.url + 'route/timetableleg/'+id);
  }
  saveRouteAndRouteLeg(data){
    return this.http.post(this.url + 'route/new',data);
  }
  updateTimetable(data){
    return this.http.put(this.url + 'route/updatelegs',data);
  }

  listRouteTimetables(id) {
    return this.http.get(this.url + 'route/timetables/' + id);
  }

  getByUserCreated(username) {
    return this.http.get(`${this.url}route/belong/${username}`);
  }

  getRouteByApplication(applicationid){
    return this.http.get(`${this.url}route/getroutebyapplication/${applicationid}`);
  }

  //set the observable value;
  set(data){
    this.placeObservable.next(data);
  }
  getplaceObservable(){
    return this.placeObservable.asObservable();
  }

}
